import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
  {
    id: 'acceptance',
    heading: '1. Acceptance and Eligibility',
    list: [
      { label: 'Agreement', text: 'Your access to and use of Aina Suite is conditioned on your acceptance of and compliance with these Terms and the associated Privacy Policy.' },
      { label: 'Age Requirement', text: 'By using this site, you represent that you are at least the age of majority in your jurisdiction. We specifically deny access to any individual covered by the Children’s Online Privacy Protection Act (COPPA).' },
      { label: 'Authority', text: 'If you are using the Service on behalf of a company or legal entity, you represent that you have the full authority to bind that entity to these terms.' },
    ],
  },
  {
    id: 'subscription',
    heading: '2. Subscription and Payment Terms',
    list: [
      { label: 'Billing', text: 'Subscriptions are billed in advance on a recurring basis (e.g., monthly or annually). Failure to pay required fees in a timely manner may result in service interruptions.' },
      { label: 'Automatic Renewal', text: 'Subscriptions automatically renew for a period equal to the original term unless canceled by the user through the provided self-service settings.' },
      { label: 'Refunds', text: 'Your purchase of Aina Suite products and services is governed by our Refund Policy. Please review the policy carefully before making a purchase, as many digital services are considered final once delivered.' },
      { label: 'Chargebacks', text: 'You agree not to initiate any chargebacks or payment disputes through your bank. Misuse of chargebacks is considered a breach of contract and may result in a permanent ban.' },
      { label: 'Free Trial', text: 'Aina Suite may offer a limited trial period. We reserve the right to modify or cancel trial offers at any time without notice.' },
    ],
  },
  {
    id: 'use-of-service',
    heading: '3. Use of Service and Prohibitions',
    subsections: [
      {
        heading: 'License',
        body: [
          'Users are granted a limited right to access the Service. You may not reproduce, duplicate, sell, or exploit any portion of the Service without express written permission.',
        ],
      },
      {
        heading: 'Prohibited Conduct',
        body: ['You agree not to use the Service for any unlawful purpose or to:'],
        list: [
          'Transmit viruses, worms, or destructive code.',
          'Infringe upon intellectual property rights.',
          'Harass, abuse, or discriminate against others.',
          'Collect or track the personal information of others.',
          'Interfere with the security features of the Service.',
        ],
      },
      {
        heading: 'Third-Party Platforms',
        body: [
          'You acknowledge that the Service relies on third-party platforms (e.g., WhatsApp, Meta). Aina Suite is not liable for bans, restrictions, or downtime imposed by these third parties.',
        ],
      },
    ],
  },
  {
    id: 'ip',
    heading: '4. Intellectual Property',
    list: [
      { label: 'Ownership', text: 'All content, trademarks, logos, and code on Aina Suite are the exclusive property of the Company or its licensors.' },
      { label: 'Submissions', text: 'Any creative ideas or feedback sent to us shall become our property and may be used for commercial purposes without compensation to you.' },
      { label: 'User Content', text: 'You are solely responsible for any content or data you provide for AI training or automation. You must ensure such content does not violate any laws or third-party rights.' },
    ],
  },
  {
    id: 'liability',
    heading: '5. Disclaimers and Limitation of Liability',
    list: [
      { label: '"As Is" Basis', text: 'The Service is provided "as is" and "as available" without warranties of any kind, either express or implied.' },
      { label: 'No Guarantee', text: 'We do not warrant that the Service will be uninterrupted, secure, or error-free, or that results obtained from its use will be accurate.' },
      { label: 'Liability Cap', text: "To the maximum extent permitted by law, Aina Suite’s liability for any claim shall not exceed the amount paid by the user in the 12 months preceding the incident." },
      { label: 'Risk', text: 'Use of the Service and any downloads are at your own risk.' },
    ],
  },
  {
    id: 'indemnification',
    heading: '6. Indemnification',
    body: [
      'You agree to indemnify and hold harmless Aina Suite and its affiliates from any claims, damages, or legal fees arising from your breach of these Terms, your misuse of the Service, or your violation of any law or third-party rights.',
    ],
  },
  {
    id: 'termination',
    heading: '7. Termination',
    list: [
      { label: 'By You', text: 'You may terminate these Terms at any time by ceasing to use the site or canceling your subscription.' },
      { label: 'By Us', text: 'We reserve the right to terminate your access immediately and without notice for a breach of these Terms.' },
    ],
  },
  {
    id: 'general',
    heading: '8. General Provisions',
    list: [
      { label: 'Modifications', text: 'We reserve the right to update these Terms at any time. It is your responsibility to monitor changes.' },
      { label: 'Severability', text: 'If any provision is found to be unenforceable, the remaining provisions will remain in full force.' },
      { label: 'Governing Law', text: 'These Terms shall be governed by the laws of the jurisdiction in which the Company is based.' },
      { label: 'Dispute Resolution', text: "Any disputes shall be resolved through binding arbitration or within the exclusive jurisdiction of the courts in the Company’s home location." },
    ],
  },
];

const contact = {
  heading: 'Contact Information',
  body: (
    <>
      Questions regarding these Terms of Use should be sent to us at <a href="mailto:hello@ainasuite.com">hello@ainasuite.com</a>.
    </>
  ),
};

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Use"
      updated="May 12, 2026"
      intro={
        <>
          Welcome to Aina Suite (<a href="https://ainasuite.com/">https://ainasuite.com/</a>). By accessing or using our website, applications, or services (collectively, the "Service"), you agree to be bound by the following Terms of Use. These terms constitute a legally binding agreement between you and Aina Suite.
        </>
      }
      sections={sections}
      contact={contact}
    />
  );
}
